import {observer} from 'mobx-react';
import React from 'react';
import {X6PageStore} from '../X6PageStore';

@observer
export class AddPushableBlockForm extends React.Component<{ store: X6PageStore }> {
  render() {
    const {store} = this.props;

    if (store.addPushableBlock === null)
      return null;

    const name = store.addPushableBlock.name;

    return (
      <div className="row" key="add-form">
        <div className="col">
          <div className={name.formGroupClassName}>
            <input className="form-control" type="text"
                   value={name.value}
                   onChange={name.onChangeHandler}
                   onKeyDown={store.completeOnEnter}
                   onBlur={name.markTouched}/>
            <div className="invalid-text">Enter name</div>
          </div>
        </div>
      </div>);
  }
}
